import { NotificationButton } from "../../components/NotificationButton";
import { useApp } from "../../services/app-context";
import { CertificationTypeSelect } from "./components/CertificationTypeSelect";
import { UserCertifications } from "./UserCertifications";
import { getLabel } from "./utils/labels";

export function UserCertificationsWrapper({ isAccountSpecialist, setCertificationType, certificationType }: { isAccountSpecialist: boolean, setCertificationType: (type: string) => void, certificationType: string }) {
  const { certificationAssets } = useApp();
  const labels = certificationAssets?.labels || {};
  return (
    <div className="bg-background p-4 pt-20 lg:p-8">
      <div className="md:mb-8 flex items-center justify-between">
        <div>
          <div className="text-text-primary text-2xl font-bold">
            {getLabel("certificationProductName", labels)}
          </div>
          <div className="text-text-primary text-lg mt-3">
            {isAccountSpecialist ? getLabel("certificationAccountSpecialistScreenSubtext", labels) : getLabel("certificationManagerAdminScreenSubtext", labels)}
          </div>
        </div>
        <div className="flex items-center gap-2">
          {!isAccountSpecialist && <CertificationTypeSelect labels={labels} setCertificationType={setCertificationType} certificationType={certificationType} />}
          <NotificationButton />
        </div>
      </div>
      <UserCertifications />
    </div>
  );
}
